<template>
	<b-container class="pt-4">
		<header>
			<b-link to="/blog"><fa :icon="fasChevronLeft" />&nbsp;Tilbage til blog-oversigt</b-link>
			<h1 v-html="post.title"></h1>
			<p>
				<small><post-timestamp :post="post" /></small>
			</p>
		</header>

		<hr>
		<b-row style="align-items: start;">
			<b-col cols="12" sm="8" class="border-right">
				<article>
					<nuxt-content :document="post" />
				</article>
			</b-col>
			<b-col cols="12" sm="4" class="d-none d-sm-block" style="position: sticky; top: 70px;">
				<p v-for="el of post.toc" :key="el.id" :class="{small: el.depth == 3, 'ml-3': el.depth == 3}" :style="{'margin-top': el.depth==3?'-.8em':''}">
					<b-link @click="go_to_header(el.id)">{{ el.text }}</b-link>
				</p>
			</b-col>
		</b-row>
		<hr>
		<div class="d-flex justify-content-between">
			<b-button v-if="prev" :to="prev.path" left><fa :icon="fasChevronLeft" />&nbsp;Ældre</b-button>
			<b-button v-if="next" :to="next.path" right>Nyere&nbsp;<fa :icon="fasChevronRight" /></b-button>
		</div>
	</b-container>
</template>

<script>
import {
	BContainer,
	BLink,
	BRow,
	BCol,
	BButton,
	BImg,
} from "bootstrap-vue";

import PostTimestamp from "~/components/PostTimestamp.vue";
import {fasChevronLeft, fasChevronRight} from "!!fa-icon-loader!~/assets/@fortawesome/fontawesome-pro/metadata/icons.json";

export default {
	components: {
		BContainer,
		BLink,
		BRow,
		BCol,
		BButton,
		BImg,

		PostTimestamp,
		LazyImage: ()=>import("~/components/LazyImage.vue")
	},
	data() {
		return {
			post: {},
			prev: false,
			next: false,
		}
	},
	computed: {
		fasChevronLeft() {return fasChevronLeft},
		fasChevronRight() {return fasChevronRight},
	},

	async asyncData ({$content, params}) {
		let post = await $content(`blog/${params.pathMatch}`, {deep:true}).fetch()

		post = JSON.parse(JSON.stringify(post).replace(/~\/assets\/blog\/([A-z0-9%./\-]+)/, (asset) => {
			asset = asset.match(/~\/assets\/blog\/([A-z0-9%./\-]+)/)[1];
			return require('../../assets/blog/' + asset);
		}))

		const [prev, next] = await $content("blog", {deep: true})
				.only(['title', 'path', 'createdAt'])
				.sortBy("createdAt", "asc")
				.surround(post.path)
				.fetch();


		return {
			post,
			prev,
			next,
		}
	},
	head() {
		return {
			title: this.post.title,
			titleTemplate: 'SkvizBiz - %s',
		}
	},
	methods: {
		scroll_to_element_id(id) {
			let el = document.getElementById(id);
				console.log("scroll to " + id);
			if (el) {
				window.scrollTo({top: el.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth'});
			}
		},

		go_to_header(id) {
			history.pushState({}, "", `#focus_${id}`);
			this.scroll_to_element_id(id);
		},
	},
	mounted() {
		this.$nextTick(()=>{
			if (this.$route.hash) {
				this.scroll_to_element_id(decodeURIComponent(this.$route.hash.substr(7)));
			}
		})
	},
}
</script>

<style lang="scss">
	article {
		font-size: 1.1em;
		line-height: 1.8em;

		p + h2 {
			margin-top: 1em;
		}

		h1,
		h2,
		h3,
		h4 {
			margin-top: .7em;
		}
		ul + p {
			margin-top: 1.5rem;
		}
		li {
			margin-bottom: .4em;
		}
		q {
			background: rgba(52, 58, 64, 0.15);
		}
		q::before,
		q::after {
			content: none;
		}
	}
	.footnotes {
		font-size: .8em;
		line-height: normal;

		> ol {
			padding-left: 1.5rem;
		}

		.footnote-backref {
			display: none;
		}
	}
	li > ul {
		margin-bottom: .5rem;
	}
	p + ul {
		margin-top: -.5rem;
	}


	.has_video_icon {
		.video_icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%) scale(1);
			color: #ff0000;
			filter: drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.3) 0px 0px 0.1em);
			transition: all .1s ease-in-out;
		}
		.shadowed {
			box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
			transition: all .1s ease-in-out;
		}

		&:hover {
			.video_icon {
				transform: translateX(-50%) translateY(-50%) scale(1.1);
				filter: drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.05em) drop-shadow(rgba(0, 0, 0, 0.5) 0px 0px 0.1em);
			}
			.shadowed {
				box-shadow: 0 .5rem 1rem rgba(0,0,0,.25);
			}
		}

	}
</style>